<template>
  <form
    v-if="store.event?.booth_data_capture"
    class="mx-auto w-full md:w-1/2 lg:w-1/3 xl:w-1/4 space-y-6"
    @submit.prevent="share"
  >
    <div v-if="store.event?.booth_data_capture && (store.event?.booth_data_capture.email && store.event?.booth_data_capture.text)">
      <div class="flex justify-center mt-4 space-x-4 flex-wrap">
        <button
          @click.prevent="kind = 'text'"
          class="sharing-button outline-none sharing-text rounded-full outline-0 border-0"
          :class="{ 'border-2 border-white': kind === 'text' }"
        >
          <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.3465 0.154785C7.97066 0.154785 0.372803 6.3278 0.372803 13.9463C0.372803 17.2343 1.79111 20.2453 4.15164 22.6124C3.3228 25.9535 0.550506 28.9312 0.517352 28.9644C0.371874 29.1169 0.332488 29.3423 0.417494 29.5413C0.444812 29.7402 0.69101 29.8595 0.902331 29.8595C5.29915 29.8595 8.59394 27.751 10.2251 26.4508C12.3933 27.267 14.8003 27.7378 17.3465 27.7378C26.7223 27.7378 34.3211 21.5647 34.3211 13.9463C34.3211 6.3278 26.7223 0.154785 17.3465 0.154785ZM11.465 16.0614C11.2396 17.3345 10.0726 18.1898 8.40165 18.1898C8.12208 18.1896 7.84295 18.1674 7.56685 18.1235C7.07551 18.0439 6.52583 17.845 6.04112 17.666C5.48998 17.4671 5.10885 16.8266 5.30578 16.2756C5.50271 15.7246 6.00797 15.3453 6.56362 15.5973C7.02638 15.7629 7.52706 15.9586 7.94811 16.0241C8.70667 16.141 9.32332 16.0017 9.37637 15.6967C9.44619 15.3047 8.6576 15.14 7.74787 14.8785C6.94423 14.6444 4.81179 14.0185 5.18643 11.8285C5.45577 10.2783 6.99727 9.44746 9.03223 9.76705C9.42384 9.82712 9.85709 9.95562 10.2649 10.0965C10.8181 10.2871 11.1123 10.8922 10.9217 11.4452C10.7357 12.0035 10.1323 12.2953 9.57529 12.103C9.28725 12.0035 8.98264 11.9082 8.70733 11.8647C7.96336 11.7549 7.33345 11.8916 7.28173 12.19C7.21476 12.5671 7.90435 12.7196 8.62047 12.9252C9.74769 13.2501 11.8496 13.8468 11.465 16.0614ZM21.5901 17.1289C21.5901 17.7153 21.1156 18.1898 20.5292 18.1898C19.9428 18.1898 19.4683 17.7124 19.4683 17.1289V13.9463L18.1959 15.643C17.7939 16.1776 16.8996 16.1776 16.4971 15.643L15.2246 13.9463V17.1289C15.2246 17.7153 14.7502 18.1898 14.1637 18.1898C13.5773 18.1898 13.1028 17.7124 13.1028 17.1289V10.7636C13.1028 10.3078 13.395 9.96133 13.8282 9.75711C14.2592 9.61826 14.7373 9.76102 15.0131 10.1278L17.3465 13.2368L19.6798 10.1251C19.9554 9.75836 20.4357 9.61773 20.8647 9.75445C21.2984 9.90165 21.5901 10.3061 21.5901 10.7636V17.1289ZM29.5005 16.0614C29.2751 17.3345 28.1081 18.1898 26.4372 18.1898C26.1576 18.1896 25.8785 18.1674 25.6024 18.1235C25.0553 18.0406 24.5043 17.8417 24.0189 17.6656C23.4678 17.4667 23.0867 16.8262 23.2836 16.2752C23.4805 15.7242 23.9858 15.4026 24.5414 15.5995C25.0042 15.7652 25.5049 15.9608 25.9259 16.0264C26.6845 16.1404 27.3038 16.0015 27.3555 15.699C27.4253 15.307 26.6367 15.1423 25.727 14.8808C24.9234 14.6466 22.7909 14.0208 23.1656 11.8307C23.4329 10.2805 24.9724 9.44971 27.0114 9.76931C27.403 9.82938 27.8362 9.95788 28.244 10.0988C28.7973 10.2894 29.0914 10.8944 28.9009 11.4474C28.7102 12.0007 28.1092 12.2968 27.5522 12.1042C27.2641 12.0048 26.9595 11.9094 26.6842 11.8659C25.9422 11.7561 25.3103 11.8929 25.2586 12.1912C25.2503 12.5671 25.9399 12.7196 26.656 12.9252C27.7832 13.2501 29.8851 13.8468 29.5005 16.0614Z" fill="white"/>
          </svg>
        </button>
        <button
          @click.prevent="kind = 'email'"
          class="sharing-button outline-none sharing-text rounded-full outline-0 border-0"
          :class="{ 'border-2 border-white': kind === 'email' }"
        >
          <svg width="28" height="21" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 21">
            <path fill="#fff" d="M.776 1.744C4.47 4.873 10.95 10.377 12.857 12.093a1.119 1.119 0 0 0 1.628 0c1.907-1.719 8.388-7.223 12.083-10.352a.561.561 0 0 0 .078-.774 2.227 2.227 0 0 0-1.759-.861H2.456A2.227 2.227 0 0 0 .697.97a.56.56 0 0 0 .079.773Zm26.03 1.695a.558.558 0 0 0-.598.081 1713.98 1713.98 0 0 0-8.011 6.829.562.562 0 0 0 .016.863c2.238 1.789 5.595 4.25 8.03 6a.561.561 0 0 0 .889-.456V3.949a.561.561 0 0 0-.326-.51ZM1.102 17.21c2.432-1.749 5.799-4.21 8.032-6a.56.56 0 0 0 .016-.863C6.752 8.28 3.555 5.57 1.139 3.519a.561.561 0 0 0-.924.428v12.808a.561.561 0 0 0 .889.455h-.002Z"/>
            <path fill="#fff" d="M26.443 18.735c-2.347-1.68-6.673-4.81-9.254-6.906a.563.563 0 0 0-.72.013c-.507.441-.931.814-1.232 1.085a2.27 2.27 0 0 1-3.13 0c-.299-.27-.722-.64-1.23-1.083a.558.558 0 0 0-.72-.013c-2.572 2.088-6.902 5.223-9.253 6.906a.56.56 0 0 0-.085.838 2.248 2.248 0 0 0 1.64.72h22.428a2.249 2.249 0 0 0 1.64-.72.563.563 0 0 0-.084-.838v-.002Z"/>
          </svg>
        </button>
      </div>
    </div>
    <StringInput
      :label="$t('data_capture.name')"
      v-model="extras.name"
    />
    <StringInput
      v-if="kind === 'email'"
      :label="$t('data_capture.email')"
      v-model="email"
      type="email"
      required
    />
    <PhoneInput
      :label="$t('data_capture.phone')"
      v-if="kind === 'text'"
      v-model="phone"
      required
    />
    <CheckboxInput
      :label="store.event?.booth_data_capture.opt_in_1_prompt"
      v-model="extras.opt_in_1"
      v-if="store.event?.booth_data_capture.opt_in_1"
    />
    <CheckboxInput
      :label="store.event?.booth_data_capture.opt_in_2_prompt"
      v-model="extras.opt_in_2"
      v-if="store.event?.booth_data_capture.opt_in_2"
    />
    <div class="flex justify-center mt-4">
      <NextBtn type="submit" />
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import StringInput from '../components/inputs/String.vue'
import CheckboxInput from '../components/inputs/Checkbox.vue'
import PhoneInput from '../components/inputs/Phone.vue'
import { useStore } from '~/stores/store'
import { create } from '../gateways/photo_deliveries'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()

const kind = ref<'text' | 'email'>('text')
const email = ref('')
const phone = ref('+1')
const extras = ref<PhotoDeliveryExtras>({
  opt_in_1: false,
  opt_in_2: false,
  name: ''
})

const destination = computed<string>(() => {
  if (kind.value === 'email') return email.value
  return phone.value
})

const share = async () => {
  if (!store.event?.booth_data_capture) return
  await create(store.photoId, 
    {
      destination: destination.value,
      extras: extras.value,
      kind: kind.value
    }
  )
  router.push({ name: 'thank_you' })
}

onMounted(() => {
  if (store.event?.booth_data_capture?.text) {
    kind.value = 'text'
  } else {
    kind.value = 'email'
  }
})

</script>
